import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	listItemLogo: {
		maxHeight: 75,
		marginRight: theme.spacing(1)
	},
	listItemTitle: {
		flex: 1,
		"&:hover": {
			textDecoration: "underline"
		},
		wordWrap: "break-word",
		display: "-webkit-box",
		WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		overflow: "hidden",
		textOverflow: "ellipsis",

		cursor: "pointer",
		fontSize: "18px"
	},
	listItemDescription: {
		flex: 1,
		color: colors.gray[500]
	},
	listItemDescription2: {
		opacity: 0.85,
		fontSize: "16px",
		fontWeight: 300
	},
	listItem: {
		padding: "8px"
	},
	chip: {
		color: colors.gray[700],
		fontSize: 14,
		height: theme.spacing(2.5)
	},
	listItemIconButton: {
		background: colors.gray[100],
		opacity: 0.8,
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		width: "64px",
		height: "64px",
		color: colors.gray[700],
		fontSize: "20px"
	},
	listItemIcon: {
		color: colors.gray[700],
		fontSize: "20px"
	},
	listItemData: {
		opacity: "0.5",
		fontSize: "14px"
	},
	icons: {
		width: "16px",
		height: "16px",
		color: colors.gray[700],
		opacity: "0.5",
		marginRight: "10px"
	}
}))

export default useStyles
